import React, {useEffect, useState} from 'react';
import {capitalizeFirstLetters, formatAccount} from "../../features/ValueFormater";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPenToSquare} from "@fortawesome/free-solid-svg-icons";
import {useDispatch} from "react-redux";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {useOutletContext} from "react-router-dom";

const LimitsView = ({limits}) => {
    const [editMode, setEditMode] = useState(false);

    const [superadminUSD, setSuperadminUSD] = useState({
        LimitPerTransaction: 0,
        LimitPerMonth: 0,
        LimitPerYear: 0
    });

    const [superadminLBP, setSuperadminLBP] = useState({
        LimitPerTransaction: 0,
        LimitPerMonth: 0,
        LimitPerYear: 0
    });

    const [adminUSD, setAdminUSD] = useState({
        LimitPerTransaction: 0,
        LimitPerMonth: 0,
        LimitPerYear: 0
    });

    const [adminLBP, setAdminLBP] = useState({
        LimitPerTransaction: 0,
        LimitPerMonth: 0,
        LimitPerYear: 0
    });

    const [errorMessage, setErrorMessage] = useState('');

    const [payload, setPayload] = useState({});

    const dispatch = useDispatch();

    const [onOpenQrAfterGenerate] = useOutletContext();

    useEffect(() => {
        setPayload({
            EmployeeLimitSuperAdminUSD: superadminUSD,
            EmployeeLimitSuperAdminLBP: superadminLBP,
            EmployeeLimitAdminUSD: adminUSD,
            EmployeeLimitAdminLBP: adminLBP
        });
    }, [superadminUSD, superadminLBP, adminUSD, adminLBP]);


    useEffect(() => {
        const superadminUSDData = limits.find(
            (limit) => limit.Role === 'SUPERADMIN' && limit.EmployeeLimits[0].CurrencyID === 1
        );
        if (superadminUSDData) {
            const { LimitPerTransaction, LimitPerMonth, LimitPerYear } = superadminUSDData.EmployeeLimits[0];
            setSuperadminUSD({
                LimitPerTransaction,
                LimitPerMonth,
                LimitPerYear
            });
        }

        const superadminLBPData = limits.find(
            (limit) => limit.Role === 'SUPERADMIN' && limit.EmployeeLimits[1].CurrencyID === 2
        );
        if (superadminLBPData) {
            const { LimitPerTransaction, LimitPerMonth, LimitPerYear } = superadminLBPData.EmployeeLimits[1];
            setSuperadminLBP({
                LimitPerTransaction,
                LimitPerMonth,
                LimitPerYear
            });
        }

        const adminUSDData = limits.find(
            (limit) => limit.Role === 'ADMIN' && limit.EmployeeLimits[0].CurrencyID === 1
        );
        if (adminUSDData) {
            const { LimitPerTransaction, LimitPerMonth, LimitPerYear } = adminUSDData.EmployeeLimits[0];
            setAdminUSD({
                LimitPerTransaction,
                LimitPerMonth,
                LimitPerYear
            });
        }

        const adminLBPData = limits.find(
            (limit) => limit.Role === 'ADMIN' && limit.EmployeeLimits[1].CurrencyID === 2
        );
        if (adminLBPData) {
            const { LimitPerTransaction, LimitPerMonth, LimitPerYear } = adminLBPData.EmployeeLimits[1];
            setAdminLBP({
                LimitPerTransaction,
                LimitPerMonth,
                LimitPerYear
            });
        }
    }, []);


    const validForm = () => {
        const objectsToValidate = [superadminUSD, superadminLBP, adminUSD, adminLBP];

        for (const obj of objectsToValidate) {
            const keys = Object.keys(obj);
            for (const key of keys) {
                if (obj[key] <= 0 || obj[key] === null) {
                    setErrorMessage('Limits Should be greater than 0');
                    return false;
                }
            }
        }

        setErrorMessage('');
        return true;
    };

    const handleSave = () => {
        if (validForm()) {
            setEditMode(false);

            dispatch(setActionType(ACTION_TYPES.EDIT_EMPLOYEE_LIMITATION));
            dispatch(setActionPayload(payload));

            onOpenQrAfterGenerate();
        }

    }

    return (
        <div className="employee-limits">
            <div className="title">EMPLOYEE LIMITS PER ACCESS LEVEL
                <div className="edit-icon">
                    {
                        !editMode &&
                        <button onClick={() => {
                            setEditMode(true);
                        }}><FontAwesomeIcon icon={faPenToSquare}/></button>
                    }
                </div>
            </div>
            {errorMessage && <span className="error">{errorMessage}</span>}
            {limits.map((roleLimits, index) => (
                <div key={index} className="my-4 limits-container">
                    <div className="subtitle mb-3">
                        {roleLimits.Role === 'SUPERADMIN'
                            ? 'SUPER ADMIN TRANSACTIONS LIMITS'
                            : 'ADMIN TRANSACTIONS LIMITS'}
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="label">Limit Per Transaction in USD</div>
                            {roleLimits.EmployeeLimits.map((employeeLimit, index) => {
                                if (employeeLimit.CurrencyID === 1) {
                                    return (
                                        <>
                                            {
                                                editMode ?
                                                    <div className="input-group">
                                                        <input type="text"
                                                               defaultValue={employeeLimit?.LimitPerTransaction}
                                                               onChange={(e) => {
                                                                   if (roleLimits.Role === 'SUPERADMIN') {
                                                                       setSuperadminUSD({
                                                                           ...superadminUSD,
                                                                           LimitPerTransaction: Number(e.target.value)
                                                                       });
                                                                   } else {
                                                                       setAdminUSD({
                                                                           ...adminUSD,
                                                                           LimitPerTransaction: Number(e.target.value)
                                                                       });
                                                                   }
                                                               }}
                                                        />
                                                        <div className="currency">$</div>
                                                    </div>
                                                    :
                                                    <p key={index}>{formatAccount(employeeLimit?.LimitPerTransaction, 1)}</p>
                                            }
                                        </>
                                    )
                                }
                            })}
                            <div className="label">Limit Per Month in USD</div>
                            {roleLimits.EmployeeLimits.map((employeeLimit, index) => {
                                if (employeeLimit.CurrencyID === 1)

                                    return (
                                        <>
                                            {
                                                editMode ?
                                                    <div className="input-group">
                                                        <input type="text"
                                                               defaultValue={employeeLimit?.LimitPerMonth}
                                                               onChange={(e) => {
                                                                   // payload[`EmployeeLimit${capitalizeFirstLetters(roleLimits.Role)}USD`].LimitPerMonth = e.target.value;
                                                                   if (roleLimits.Role === 'SUPERADMIN') {
                                                                       setSuperadminUSD({
                                                                           ...superadminUSD,
                                                                           LimitPerMonth: Number(e.target.value)
                                                                       });
                                                                   } else {
                                                                       setAdminUSD({
                                                                           ...adminUSD,
                                                                           LimitPerMonth: Number(e.target.value)
                                                                       });
                                                                   }
                                                               }
                                                               }
                                                        />
                                                        <div className="currency">$</div>
                                                    </div>
                                                    :
                                                    <p key={index}>{formatAccount(employeeLimit?.LimitPerMonth, 1)}</p>
                                            }
                                        </>
                                    )
                            })
                            }
                            <div className="label">Limit Per Year in USD</div>
                            {roleLimits.EmployeeLimits.map((employeeLimit, index) => {
                                    if (employeeLimit.CurrencyID === 1)
                                        return (
                                            <>
                                                {
                                                    editMode ?
                                                        <div className="input-group">
                                                            <input type="text"
                                                                   defaultValue={employeeLimit?.LimitPerYear}
                                                                   onChange={(e) => {
                                                                       // payload[`EmployeeLimit${capitalizeFirstLetters(roleLimits.Role)}USD`].LimitPerYear = e.target.value;
                                                                       if (roleLimits.Role === 'SUPERADMIN') {
                                                                           setSuperadminUSD({
                                                                               ...superadminUSD,
                                                                               LimitPerYear: Number(e.target.value)
                                                                           });
                                                                       } else {
                                                                           setAdminUSD({
                                                                               ...adminUSD,
                                                                               LimitPerYear: Number(e.target.value)
                                                                           });
                                                                       }
                                                                   }
                                                                   }
                                                            />
                                                            <div className="currency">$</div>
                                                        </div>
                                                        :
                                                        <p key={index}>{formatAccount(employeeLimit?.LimitPerYear, 1)}</p>
                                                }
                                            </>
                                        )
                                }
                            )}
                        </div>
                        <div className="col-md-6">
                            <div className="label">Limit Per Transaction in LBP</div>
                            {roleLimits.EmployeeLimits.map((employeeLimit, index) => {
                                    if (employeeLimit.CurrencyID === 2)
                                        return (
                                            <>
                                                {
                                                    editMode ?
                                                        <div className="input-group">
                                                            <input type="text"
                                                                   defaultValue={employeeLimit?.LimitPerTransaction}
                                                                   onChange={(e) => {
                                                                       // payload[`EmployeeLimit${capitalizeFirstLetters(roleLimits.Role)}LBP`].LimitPerTransaction = e.target.value;
                                                                       if (roleLimits.Role === 'SUPERADMIN') {
                                                                           setSuperadminLBP({
                                                                               ...superadminLBP,
                                                                               LimitPerTransaction: Number(e.target.value)
                                                                           });
                                                                       } else {
                                                                           setAdminLBP({
                                                                               ...adminLBP,
                                                                               LimitPerTransaction: Number(e.target.value)
                                                                           });
                                                                       }
                                                                   }
                                                                   }
                                                            />
                                                            <div className="currency">L.L</div>
                                                        </div>
                                                        :
                                                        <p key={index}>{formatAccount(employeeLimit?.LimitPerTransaction, 2)}</p>
                                                }
                                            </>
                                        )
                                }
                            )}
                            <div className="label">Limit Per Month in LBP</div>
                            {roleLimits.EmployeeLimits.map((employeeLimit, index) => {
                                    if (employeeLimit.CurrencyID === 2)
                                        return (
                                            <>
                                                {
                                                    editMode ?
                                                        <div className="input-group">
                                                            <input type="text"
                                                                   defaultValue={employeeLimit?.LimitPerMonth}
                                                                   onChange={(e) => {
                                                                       // payload[`EmployeeLimit${capitalizeFirstLetters(roleLimits.Role)}LBP`].LimitPerMonth = e.target.value;
                                                                       if (roleLimits.Role === 'SUPERADMIN') {
                                                                           setSuperadminLBP({
                                                                               ...superadminLBP,
                                                                               LimitPerMonth: Number(e.target.value)
                                                                           });
                                                                       } else {
                                                                           setAdminLBP({
                                                                               ...adminLBP,
                                                                               LimitPerMonth: Number(e.target.value)
                                                                           });
                                                                       }
                                                                   }
                                                                   }
                                                            />
                                                            <div className="currency">L.L</div>
                                                        </div>
                                                        :
                                                        <p key={index}>{formatAccount(employeeLimit?.LimitPerMonth, 2)}</p>
                                                }
                                            </>
                                        )
                                }
                            )}
                            <div className="label">Limit Per Year in LBP</div>
                            {roleLimits.EmployeeLimits.map((employeeLimit, index) => {
                                    if (employeeLimit.CurrencyID === 2)
                                        return (
                                            <>
                                                {
                                                    editMode ?
                                                        <div className="input-group">
                                                            <input type="text"
                                                                   defaultValue={employeeLimit?.LimitPerYear}
                                                                   onChange={(e) => {
                                                                       // payload[`EmployeeLimit${capitalizeFirstLetters(roleLimits.Role)}LBP`].LimitPerYear = e.target.value;
                                                                       if (roleLimits.Role === 'SUPERADMIN') {
                                                                           setSuperadminLBP({
                                                                               ...superadminLBP,
                                                                               LimitPerYear: Number(e.target.value)
                                                                           });
                                                                       } else {
                                                                           setAdminLBP({
                                                                               ...adminLBP,
                                                                               LimitPerYear: Number(e.target.value)
                                                                           });
                                                                       }
                                                                   }
                                                                   }
                                                            />
                                                            <div className="currency">L.L</div>
                                                        </div>
                                                        :
                                                        <p key={index}>{formatAccount(employeeLimit?.LimitPerYear, 2)}</p>
                                                }
                                            </>
                                        )
                                }
                            )}
                        </div>
                    </div>
                </div>
            ))}
            {
                editMode &&
                <div className="text-center">
                    <button className="save-btn" onClick={handleSave}>Save</button>
                </div>
            }
        </div>
    );
};

export default LimitsView;
